import { render, staticRenderFns } from "./VideoHero.vue?vue&type=template&id=e4f1bc58&scoped=true&"
import script from "./VideoHero.vue?vue&type=script&lang=js&"
export * from "./VideoHero.vue?vue&type=script&lang=js&"
import style0 from "./VideoHero.vue?vue&type=style&index=0&id=e4f1bc58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f1bc58",
  null
  
)

export default component.exports